module.exports = __webpack_public_path__ + "img/case_stucomm_portrait.050b82c4.jpg";